import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import agentProgressReducer from './slices/agentProgressSlice';
import { authApi } from './api/authApi';
import { githubApi } from './api/githubApi';
import { adminApi } from './api/adminApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    agentProgress: agentProgressReducer,
    [authApi.reducerPath]: authApi.reducer,
    [githubApi.reducerPath]: githubApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware, githubApi.middleware, adminApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
